module.exports = __webpack_public_path__ + "static/img/teaser.f2e99ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/teaser.png
// module id = PYow
// module chunks = 0